import { actionCopyIt } from "./actionCopy";

export const ratingsListCopyIt = {
    addActivityPlaceholder: (current: number, max: number) => `Aggiungi l'attività ${current}/${max}`,
    add: actionCopyIt.add,
    emptyHint: "Aggiunga delle attività qui sopra per iniziare a valutare la Sua difficoltà",
    noDifficulty: "Nessuna difficoltà",
    unableToDo: "Impossibile da svolgere",
    loading: "Caricamento delle attività...",
    loadError: "Impossibile caricare il Suo elenco di attività. Riprovi.",
    noBaselineActivities:
        "Non è stata trovata alcuna attività di riferimento per questo monitoraggio. Completi il primo inserimento prima di inviare un controllo.",
    followUpHint: "Valuti la Sua difficoltà attuale per ogni attività scelta durante l'inserimento iniziale.",
};
